import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';

import { PendingRequestsTable } from '@/modules/home';
import { TransactionsTable } from '@/modules/home';
import { InventoryTabs } from '@/modules/home/components/PageContent/Inputs/Inventory/Tabs';
import { TAB_QUERY_INDICATOR } from '@/modules/home/components/PageContent/Inputs/Inventory/Tabs';
import HomeCardWrapper from '@/modules/home/components/shared/CardWrapper';

import Packhouse from '~/images/shared/Packhouse.svg';

const InventoryWidget = () => {
  const { t } = useTranslation();
  const { query } = useRouter();

  const selectedTab = query?.[TAB_QUERY_INDICATOR] as
    | 'transactions'
    | 'pendingRequests'
    | undefined;

  return (
    <HomeCardWrapper
      headerTabs={<InventoryTabs />}
      title={t('Inventory')}
      icon={<Packhouse width='24' height='24' />}
    >
      {
        {
          transactions: <TransactionsTable />,
          pendingRequests: <PendingRequestsTable />,
        }[selectedTab || 'pendingRequests']
      }
    </HomeCardWrapper>
  );
};

export { InventoryWidget };
